import React from "react";
import { labelUtils } from "../Util";
import FormGroupWrapper from "./FormGroupWrapper";
import store from "../../../../store";
import { setRendererFormState } from "../../../../store/slices/commonSlice";

const Decimal = ({
  arrEle,
  newElfromJSON,
  fieldEle,
  formState,
  displayLabelKey,
  databaseKey,
}) => {
  let key = databaseKey ? databaseKey : displayLabelKey;

  return (
    <FormGroupWrapper
      arrEle={arrEle}
      newElfromJSON={newElfromJSON}
      fieldEle={fieldEle}
    >
      <div
        className="form-builder-element"
        style={{ width: labelUtils.getElementWidth(fieldEle) }}
      >
        <input
          id={newElfromJSON}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
            }
          }}
          type="number"
          className="form-control inputDecimal"
          inputMode="decimal"
          placeholder={fieldEle?.["display-placeholder"]}
          name={key}
          // pattern="[0-9.0-9]*"
          pattern={`^[0-9]*(?:\.[0-9]{1,${fieldEle?.["data-decimalplaces"]}})?$`}
          disabled={fieldEle?.["display-disabled"] === 1}
          required={fieldEle?.["display-required"] === 1}
          min={fieldEle?.["validation-minvalue"]}
          max={fieldEle?.["validation-maxvalue"]}
          value={formState[key] || ""}
          onChange={(e) =>
            store.dispatch(
              setRendererFormState({ key, value: e.target.value })
            )
          }
        />
        <div className="invalid-feedback">This field is required</div>
        {fieldEle?.["display-description"] && (
          <div className="form-text text-muted formElementDesc">
            {fieldEle?.["display-description"]}
          </div>
        )}
      </div>
    </FormGroupWrapper>
  );
};

export default Decimal;
